import { BrowserRouter, Routes, Route } from "react-router-dom";

import "./index.css";
import "./css/header.css";
import "./css/home.css";
import "./css/search.css";
import "./css/cards.css";
import "./css/qualities.css";
import "./css/footer.css";
import "./css/inviewport.css";
import "./css/details.css";
import "./css/forms.css";
import "./css/order.css";
import "./css/alert.css";
import "./css/admin.css";
import "./css/dashboard.css";
import "./css/cart-list.css";
import "./css/scroll-to-top.css";
import "./css/filter.css";

import { PageNotFound } from "./features/notfound/four-oh-four";
import { HomePage } from "./features/homepage/home";
import { CarDetails } from "./features/details/details";
import { OrderForm } from "./features/order/order";
import { LoginPage } from "./features/admin/signin";
import { AdminDashboard } from "./features/admin/dashboard";
import { AuthenticationContextProvider } from "./services/authentication/authentication.context";
import { LoadingIndicator } from "./components/utilities/loader";
import { ProtectedRoutes } from "./components/auth/protected-route";
import { CarAddForm } from "./features/dashboard/add.car";
import { CarContextProvider } from "./services/products/product.context";
import { Catalog } from "./features/catalog/catalog";
import { CartListContainer } from "./components/utilities/cart-list-container";
import { CartContextProvider } from "./services/cart/cart.context";
import { WishList } from "./features/saved/wishlist";
import { SearchForm } from "./components/utilities/search-form";
import { UpdateDeletePage } from "./features/dashboard/update-delete-page";
import { CarUpdateForm } from "./features/dashboard/update.car";
import { AuthPage } from "./features/admin/auth";
import { ScrollToTopButton } from "./components/utilities/scroll-to-top";


function App() {
  return (
    <BrowserRouter>
      <AuthenticationContextProvider>
        <CarContextProvider>
          <CartContextProvider>
            <LoadingIndicator />
            <CartListContainer />
            <ScrollToTopButton />
            <SearchForm />
            <Routes>
              <Route path="*" element={<PageNotFound />} />
              <Route path="/" element={<HomePage />} />
              <Route path="/details" element={<CarDetails />} />
              <Route path="/order" element={<OrderForm />} />
              <Route path="/signin" element={<LoginPage />} />
              <Route path="/catalog" element={<Catalog />} />
              <Route path="/wishlist" element={<WishList />} />
              <Route element={<ProtectedRoutes />}>
                <Route path="/admin_auth" element={<AuthPage />} />
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/addcar" element={<CarAddForm />} />
                <Route path="/update_delete" element={<UpdateDeletePage />} />
                <Route path="/updatecar" element={<CarUpdateForm />} />
              </Route>
            </Routes>
          </CartContextProvider>
        </CarContextProvider>
      </AuthenticationContextProvider>
    </BrowserRouter>
  );
}

export default App;
